import type { Addresses } from 'api/types/addresses.types';
import { updateNewOrder } from 'pages/newOrder/newOrder.slice';
import { useEditCustomerAddress } from 'pages/queries/address.queries';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import type { AppDispatch } from 'redux-stores/store';
import type { AddressForm } from 'schemas/address-schema';

import { AddressFormPage } from '../components/AddressFormPage';
import { AddressGeofence } from '../components/AddressGeoFence';
import { AddressSearch } from '../components/AddressSearch';
import { AddressType } from '../components/AddressType';

interface Props {}

interface LocationState {
  address: Addresses.Address;
  goBack?: boolean;
}

const EditAddressPage: React.FC<Props> = () => {
  const location = useLocation();
  const { address, goBack } = location.state as LocationState;
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [selectedAddress] = React.useState(address);

  const resetTimeslots = () => {
    dispatch(
      updateNewOrder({
        pickupTimeslot: undefined,
        dropoffTimeslot: undefined,
      })
    );
  };

  const { mutateAsync: editAddress, isLoading } = useEditCustomerAddress({
    onSuccess: () => {
      resetTimeslots();
      if (goBack) {
        navigate(-1);
      } else {
        navigate('/newOrder');
      }
    },
  });

  const handleEditAddress = useCallback(
    async (addressForm: AddressForm) => {
      await editAddress({
        address: addressForm,
        addressId: selectedAddress.id,
      });
    },
    [editAddress, selectedAddress.id]
  );

  if (!selectedAddress) {
    return <Navigate to="/newOrder" />;
  }

  return (
    <Routes>
      <Route path="addressFormPage" element={<AddressFormPage action="update" isLoading={isLoading} onSubmit={handleEditAddress} />} />
      <Route path="addressType" element={<AddressType />} />
      <Route path="addressGeofence" element={<AddressGeofence />} />
      <Route index element={<AddressSearch defaultAddress={address} />} />
    </Routes>
  );
};

export default EditAddressPage;
